import React, { useEffect, useLayoutEffect, useState } from 'react'
import './App.css'
import './components/SideBar.css'
import './components/BottomBar.css'
import { Routes, useLocation } from 'react-router-dom'
import BottomBar from './components/BottomBar'
import { SideBar } from './components/SideBar'
import { AppRoutes } from './AppRoutes'
import { LayoutProvider, useLayout } from './context/LayoutContext'
import { useLang, translate } from './components/Locale'
import LanguageOption from './components/LanguageOption'

type State = 'desktop' | 'mobile'

function calcState(): State {
  if (window.innerWidth > window.innerHeight) {
    return 'desktop'
  } else {
    return 'mobile'
  }
}

function AppContent() {
  const [state, setState] = useState<State>(calcState)
  const { config } = useLayout()
  const { lang } = useLang()
  const location = useLocation()

  // Function to render title based on type
  const renderTitle = () => {
    if (!config.title) return null

    if (typeof config.title === 'string') {
      return <span>{config.title}</span>
    } else {
      // It's a multilingual title object
      return <span>{translate(lang, config.title)}</span>
    }
  }

  useEffect(() => {
    function check() {
      setState(calcState())
    }
    window.addEventListener('resize', check)
    return () => {
      window.removeEventListener('resize', check)
    }
  }, [])

  useLayoutEffect(() => {
    document.body.dataset.mode = state
  }, [state])

  // Set data-page attribute based on current route
  useLayoutEffect(() => {
    const pathname = location.pathname
    if (pathname === '/' || pathname === '/home') {
      document.body.dataset.page = 'home'
    } else {
      delete document.body.dataset.page
    }
  }, [location.pathname])

  return (
    <div className="app">
      {/* Header - only show in mobile mode and when enabled by page */}
      {state === 'mobile' && config.showHeader && (
        <header className="header">
          {renderTitle()}
          <div className="header-lang">
            <LanguageOption />
          </div>
        </header>
      )}

      {/* Sidebar - only show in desktop mode and when enabled by page */}
      {state === 'desktop' && config.showSidebar && (
        <aside className="sidebar">
          <SideBar />
        </aside>
      )}

      {/* Main content - always show */}
      <main className="main-content">
        <Routes>{AppRoutes}</Routes>
      </main>

      {/* Footer - only show in mobile mode and when enabled by page */}
      {state === 'mobile' && config.showFooter && (
        <footer className="bottom-menu">
          <BottomBar />
        </footer>
      )}
    </div>
  )
}

export default function App() {
  return (
    <LayoutProvider>
      <AppContent />
    </LayoutProvider>
  )
}
